import { Map, List, fromJS } from 'immutable'

export function eventLog(state = Map(), action) {
  if (action.type === 'EVENT_ADD_LISTENER') {
    let { id, filters } = action

    if (!Map.isMap(filters)) filters = fromJS(filters)

    state = state.set(id, Map().set('filters', filters).set('loading', true))
  }

  if (action.type === 'EVENT_LOG_INIT') {
    let { id, data: { meta, items } = {} } = action

    state = state.setIn([id, 'items'], fromJS(items)).setIn([id, 'meta'], fromJS(meta)).setIn([id, 'loading'], false)
  }

  if (action.type === 'EVENT_LOG_ERROR') {
    let { id, message } = action
    state = state.setIn([id, 'error'], message)
  }

  if (action.type === 'EVENT_REMOVE_LISTENER') {
    let { id } = action
    state = state.remove(id)
  }

  if (action.type === 'EVENT_PUSH' || action.type === 'EVENT_CREATE_NOTE_SUCCESS') {
    let { events } = action
    state = state.map((data, id) => {
      let filters = data.get('filters', Map())
      let items = events.reduce((items, event) => {
        /* Go through all filters and check if event shuold be included to list */
        let test = filters.reduce((test, testValue, key) => {
          if (!test) return test

          let value = event.get(key, false)

          if (List.isList(testValue)) return testValue.contains(value)

          return value === testValue
        }, true)

        if (test) return items.unshift(event)

        return items
      }, data.get('items', List()))

      return data.set('items', items)
    })
  }

  if (action.type === 'EVENT_TOGGLE_NOTE_EDITOR') {
    let { id, open = true } = action
    state = state.setIn([id, 'noteEditorOpen'], open)
  }

  if (action.type === 'EVENT_CREATE_NOTE_SAVING') {
    let { id, saving = true } = action
    state = state.setIn([id, 'noteEditorSaving'], saving)
  }

  if (action.type === 'EVENT_CREATE_NOTE_ERROR') {
    let { id, message = true } = action
    state = state.setIn([id, 'noteEditorError'], message)
  }

  if (action.type === 'EVENT_CREATE_NOTE_SUCCESS') {
    let { id } = action
    state = state
      .setIn([id, 'noteEditorOpen'], false)
      .setIn([id, 'noteEditorSaving'], false)
      .setIn([id, 'noteEditorError'], false)
  }

  return state
}
